import PropTypes from "prop-types"
import { StaticImage } from "gatsby-plugin-image"
import React from "react"

const texts = {
  pt: [
    "Ajudando a trazer evidências para a medicina translacional",
    "Ajudando a investigar a validade experimental em diferentes domínios de pesquisa pré-clínica",
    "Promovendo o compartilhamento de dados e ferramentas de análise de dados",
  ],
  en: [
    "Helping bring evidence to translational medicine",
    "Helping to investigate experimental validity in different domains of preclinical research ",
    "Promoting data sharing and data analysis tools",
  ],
}

function Objectives({ language }) {
  const text = texts[language]

  return (
    <section>
      <div className="row">
        <div className="col-md-6 col-sm-12 row">
          <h2>{text[0]}</h2>
          <div className="col-6">
            <div>
              <StaticImage
                src="../../../assets/images/icons/transparent-bg-globe.png"
                alt="globe-icon"
              />
            </div>
            <p>{text[1]}</p>
          </div>
          <div className="col-6">
            <div>
              <StaticImage
                src="../../../assets/images/icons/transparent-bg-globe.png"
                alt="globe-icon"
              />
            </div>
            <p>{text[2]}</p>
          </div>
        </div>
        <div className="col-md-6 col-sm-12">
          <StaticImage
            src="../../../assets/images/generics/about-lab.png"
            alt="Sobre CAMARADES BR"
          />
        </div>
      </div>
    </section>
  )
}

Objectives.propTypes = {
  language: PropTypes.oneOf(["pt", "en"]),
}

export default Objectives
